<!--  -->
<template>
  <div class="main_w">
    <CellGroup title="猜你想要">
      <Row style="margin: 0 0.2rem">
        <Col
          v-if="source === 'consumer'"
          span="6"
          @click="
            navigateTo({
              url: `szbb://weexpage?weexFileName=demand/demand-publish.js`,
              miniAppUrl: `/pages/platform/platform`,
              isTabPage: true,
            })
          "
        >
          <img
            src="@/assets/images/help/baogaoshurumokuaitubiao-.png"
            alt=""
            class="v1_img"
          />
          <p class="v1_t">发布需求</p>
        </Col>
        <Col
          span="6"
          @click="
            navigateTo({
              url:
                idCardAuditStatus === '1'
                  ? `szbb://weexpage?weexFileName=mine/mine-info-realname.js`
                  : 'szbb://weexpage?weexFileName=mine/mine-upload-idcard.js',
              miniAppUrl:
                idCardAuditStatus === '1'
                  ? `/subpackages/account/pages/changeRealName/index`
                  : '/subpackages/account/pages/identificidcard/identificidcard',
            })
          "
        >
          <img
            src="@/assets/images/help/accreditation.png"
            alt=""
            class="v1_img"
          />
          <p class="v1_t">实名认证</p>
        </Col>
        <Col
          v-if="source === 'consumer'"
          span="6"
          @click="
            navigateTo({
              url: `szbb://weexpage?weexFileName=mine/mine-invoice-page.js`,
              miniAppUrl: `invoice`,
            })
          "
        >
          <img
            src="@/assets/images/help/tianmaotigongfapiao.png"
            alt=""
            class="v1_img"
          />
          <p class="v1_t">申请发票</p>
        </Col>
        <Col
          v-if="source === 'engineer'"
          span="6"
          @click="
            navigateTo({
              url: `szbb://weexpage?weexFileName=mine/mine-withdraw-list.js`,
              miniAppUrl: `/subpackages/account/pages/withdrawlist/withdrawlist`,
              params: { pageFlag: 'mine_invoice' },
            })
          "
        >
          <img src="@/assets/images/help/withdraw.png" alt="" class="v1_img" />
          <p class="v1_t">订单提现</p>
        </Col>
        <Col v-if="isWeixin" span="6"></Col>
        <Col
          v-else
          span="6"
          @click="
            navigateTo({
              url: `szbb://weexpage?weexFileName=mine/mine-change-password.js`,
              miniAppUrl: `/subpackages/account/pages/changepassword/changepassword`,
            })
          "
        >
          <img src="@/assets/images/help/password.png" alt="" class="v1_img" />
          <p class="v1_t">修改密码</p>
        </Col>
        <template v-if="source === 'engineer'">
          <Col v-if="isWeixin" span="6"></Col>
          <Col
            v-else
            span="6"
            @click="
              navigateTo({
                url: `szbb://weexpage?weexFileName=mine/mine-change-phonenum.js`,
                miniAppUrl: `/subpackages/account/pages/changephone/changephone`,
              })
            "
          >
            <img
              src="@/assets/images/help/phonenum.png"
              alt=""
              class="v1_img"
            />
            <p class="v1_t">手机换绑</p>
          </Col></template
        >
      </Row>
    </CellGroup>
    <CellGroup title="猜你想问">
      <template v-if="source === 'engineer'">
        <Cell
          title="提现几天可以到账？"
          is-link
          :to="{ name: 'qaDetail', query: { id: '1' } }"
        />
        <Cell
          title="怎么样才能提高自己的中标率？"
          is-link
          :to="{ name: 'qaDetail', query: { id: '2' } }"
        />
        <Cell
          title="邦邦平台收取平台管理费吗？"
          is-link
          :to="{ name: 'qaDetail', query: { id: '3' } }"
        />
      </template>
      <template v-if="source === 'consumer'">
        <Cell
          title="如何注册公司？"
          is-link
          url="https://c.shenzhoubb.com/article/1611218733820"
        />
        <Cell
          title="预算价格可以修改吗？"
          is-link
          :to="{ name: 'qaDetail', query: { id: '10' } }"
        />
      </template>
    </CellGroup>
    <CellGroup title="使用手册">
      <Row style="margin: 0 0.2rem">
        <Col span="6">
          <a href="https://c.shenzhoubb.com/article/1668075416786">
            <img src="@/assets/images/help/01.png" alt="" class="v1_img" />
            <p class="v1_t">平台手册</p></a
          >
        </Col>
        <Col v-if="source === 'engineer'" span="6">
          <a
            :href="`${publicPath}pdf/web/viewer.html?file=工程师接单操作指南V2.pdf`"
          >
            <img src="@/assets/images/help/03.png" alt="" class="v1_img" />
            <p class="v1_t">工程师指南</p>
          </a>
        </Col>
        <Col v-if="source === 'consumer'" span="6">
          <a :href="`${publicPath}pdf/web/viewer.html?file=发单指引(1).pdf`">
            <img src="@/assets/images/help/04.png" alt="" class="v1_img" />
            <p class="v1_t">发单指引</p>
          </a>
        </Col>
        <Col span="6">
          <router-link :to="{ name: 'rules' }">
            <img src="@/assets/images/help/05.png" alt="" class="v1_img" />
            <p class="v1_t">规则中心</p>
          </router-link>
        </Col>
      </Row>
    </CellGroup>
    <CellGroup title="常见问题">
      <Collapse v-model="activeNames">
        <Cell
          title="服务流程"
          is-link
          :to="{ name: 'qaDetail', query: { id: '0' } }"
        >
          <Icon
            slot="icon"
            name="flag-o"
            class="van-cell__left-icon"
            color="#1989fa"
          />
        </Cell>
        <CollapseItem title="注册相关" name="2">
          <Icon
            slot="icon"
            name="user-circle-o"
            class="van-cell__left-icon"
            color="#1989fa"
          />
          <div style="margin: -0.24rem 0">
            <Cell
              v-if="source === 'consumer'"
              title="公司注册流程"
              is-link
              url="https://c.shenzhoubb.com/article/1611218733820"
            />
            <Cell
              v-if="source === 'engineer'"
              title="工程师注册流程"
              is-link
              url="https://c.shenzhoubb.com/article/1611214086406"
            />
            <Cell
              v-if="source === 'engineer'"
              title="为什么没有通过认证就不能报名订单？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '4' } }"
            />
            <Cell
              title="为什么在个人信息中必须设置昵称和头像？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '5' } }"
            />
            <Cell
              v-if="source === 'engineer'"
              title="怎么样才能让自己中标率高一点？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '2' } }"
            />
          </div>
        </CollapseItem>
        <CollapseItem v-if="source === 'engineer'" title="接单相关" name="3">
          <Icon
            slot="icon"
            name="completed"
            class="van-cell__left-icon"
            color="#1989fa"
          />
          <div style="margin: -0.24rem 0">
            <Cell
              title="我被选中了，可以主动取消报名吗？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '6' } }"
            />
            <Cell
              title="公司接单步骤详解"
              is-link
              url="https://c.shenzhoubb.com/article/1611221632702"
            />
            <Cell
              title="工程师接单步骤详解"
              is-link
              url="https://c.shenzhoubb.com/article/1611222298846"
            />
            <Cell
              title="邦备件接单步骤详解"
              is-link
              url="https://c.shenzhoubb.com/article/1611628798747"
            />
          </div>
        </CollapseItem>
        <CollapseItem v-if="source === 'consumer'" title="发单相关" name="4">
          <Icon
            slot="icon"
            name="records"
            class="van-cell__left-icon"
            color="#1989fa"
          />
          <div style="margin: -0.24rem 0">
            <Cell
              title="公司发单"
              is-link
              url="https://c.shenzhoubb.com/article/1611220865118"
            />
            <Cell
              title="在托管服务费之前，客户可以取消订单吗？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '7' } }"
            />
            <Cell
              title="客户托管服务费之后。可以取消订单吗？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '8' } }"
            />
          </div>
        </CollapseItem>
        <CollapseItem v-if="source === 'engineer'" title="结算相关" name="5">
          <Icon
            slot="icon"
            name="pending-payment"
            class="van-cell__left-icon"
            color="#1989fa"
          />
          <div style="margin: -0.24rem 0">
            <Cell
              title="提现几天可以到账？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '1' } }"
            />
            <Cell
              title="客户的预算价格就是最终价格吗？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '9' } }"
            />
            <Cell
              title="客户的预算价格可以修改吗？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '10' } }"
            />
            <Cell
              title="邦邦平台收取平台管理费吗？"
              is-link
              :to="{ name: 'qaDetail', query: { id: '3' } }"
            />
          </div>
        </CollapseItem>
        <CollapseItem title="制度相关" name="6">
          <Icon
            slot="icon"
            name="todo-list-o"
            class="van-cell__left-icon"
            color="#1989fa"
          />
          <div style="margin: -0.24rem 0">
            <template v-if="source === 'engineer'">
              <Cell
                title="星级的评分标准是什么？"
                is-link
                :to="{ name: 'qaDetail', query: { id: '11' } }"
              />
              <Cell
                title="关于对工程师爽约的处罚"
                is-link
                :to="{ name: 'qaDetail', query: { id: '12' } }"
              />
            </template>
            <Cell
              title="纠纷处理"
              is-link
              :to="{ name: 'qaDetail', query: { id: '13' } }"
            />
            <Cell
              title="怎样方便的找到客服或者提出意见建议?"
              is-link
              :to="{ name: 'qaDetail', query: { id: '14' } }"
            />
          </div>
        </CollapseItem>
      </Collapse>
    </CellGroup>
    <div class="v3">
      <p>
        以上都没解决您的问题？<span style="color: red" @click="toChat"
          >在线客服</span
        >竭诚为您服务
      </p>
      <p>工作日：周一至周五 9：00-18：00</p>
    </div>
  </div>
</template>

<script>
import basePage from "@/pages/basePage.vue";
import {
  Cell,
  CellGroup,
  Col,
  Row,
  Collapse,
  CollapseItem,
  Icon,
  Dialog,
} from "vant";
import {
  isBangBangApp,
  getWXEvn,
  isWeixin,
  isAndroid,
  isIOS,
  postMessageToAPP,
} from "@/utils";
import wx from "@/assets/js/jweixin-1.6.0";
export default {
  extends: basePage,
  //import引入的组件需要注入到对象中才能使用
  components: {
    Cell,
    CellGroup,
    Col,
    Row,
    Collapse,
    CollapseItem,
    Icon,
  },
  data() {
    //这里存放数据
    return {
      activeNames: ["2", "3", "4", "5", "6"],
      isWeixin: isWeixin(),
      publicPath: process.env.VUE_APP_PUBLICPATH,
      source: "",
      idCardAuditStatus: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toChat() {
      if (isWeixin()) {
        getWXEvn({
          //如果是小程序
          isMiniApp: () => {
            wx.miniProgram.navigateTo({
              url: "/subpackages/common/pages/webServiceChat/index",
            });
          },
        });
      } else if (isBangBangApp) {
        postMessageToAPP({
          selName: "openWeiXinKefu",
          paramsDic: {},
        });
      }
    },
    navigateTo({ url, miniAppUrl, params, isTabPage }) {
      if (isBangBangApp()) {
        if (isAndroid()) {
          window.synopsis.navigateTo(
            `${url}&weexParamJson=${params ? JSON.stringify(params) : ""}`
          );
          return;
        }
        if (isIOS()) {
          window.webkit.messageHandlers.navigateTo.postMessage(
            `${url}&weexParamJson=${params ? JSON.stringify(params) : ""}`
          );
        }
      }
      if (this.isWeixin) {
        getWXEvn({
          isMiniApp: () => {
            if (miniAppUrl === "invoice") {
              Dialog.alert({
                title: "提示",
                message: "该功能暂未实现，请到神州邦邦App中使用",
              }).then(() => {
                // on close
              });
              return;
            }
            if (isTabPage) {
              wx.miniProgram.switchTab({
                url: miniAppUrl,
              });
              return;
            }
            wx.miniProgram.navigateTo({
              url: miniAppUrl,
            });
          },
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.source = this.$route.query.source;
    this.idCardAuditStatus = this.$route.query.idCardAuditStatus;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.main_w {
  background-color: #f5f7fa;
  width: 100%;
  padding-bottom: 1rem;
}
.v1_img {
  width: 0.6rem;
  height: 0.6rem;
  display: block;
  margin: 0.2rem auto;
}
.v1_t {
  font-size: 0.24rem;
  color: #323232;
  text-align: center;
  margin-bottom: 0.2rem;
}
.v3 {
  font-size: 0.24rem;
  margin: 0.4rem 0.32rem;
  p {
    line-height: 0.3rem;
    text-align: center;
  }
}
/deep/.van-cell__right-icon {
  color: #ccc;
}
</style>